<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRoute, RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import NavBar from './components/common/NavBar.vue'
import Footer from './components/common/Footer.vue'
import SourceCitationPrompt from './components/SourceCitationPrompt.vue'
import TutorialWalkthrough from './components/common/TutorialWalkthrough.vue'

const auth = useAuthStore()
const route = useRoute()
const sourceReview = ref(null)

const isNonNavPage = computed(() =>
  ['/', '/reset_password', '/forgot_password'].includes(route.path)
)

onMounted(async () => {
  window.addEventListener('change-review-submitted', showSourcePrompt)
  await auth.fetchMe()
})

onUnmounted(() => {
  window.removeEventListener('change-review-submitted', showSourcePrompt)
})

function showSourcePrompt(event) {
  sourceReview.value = event.detail
}

function closeSourcePrompt() {
  sourceReview.value = null
}
</script>

<template>
  <div class="app-shell" :class="{ 'app-shell--no-nav': isNonNavPage }">
    <NavBar v-if="!isNonNavPage" />

    <main class="app-main" data-tutorial="page-content">
      <RouterView />
    </main>

    <Footer />

    <SourceCitationPrompt
      :show="Boolean(sourceReview)"
      :review="sourceReview || {}"
      @close="closeSourcePrompt"
      @saved="closeSourcePrompt"
    />

    <TutorialWalkthrough
      v-if="!isNonNavPage"
      :current-path="route.path"
    />
  </div>
</template>
